export default __webpack_public_path__ + "static/media/orchid_flowers.d770f90a.jpg";